'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024101 from "./presto.types$$anon$101.js";
import * as $j_presto$002etypes$0024$0024anon$002495 from "./presto.types$$anon$95.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
import * as $j_presto$002etypes$0024$002dTime$002dPayload$0024 from "./presto.types$-Time-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$94(outer) {
  this.cav = null;
  this.can = null;
  this.cao = false;
  this.caw = null;
  this.cax = false;
  this.caA = null;
  this.cat = null;
  this.cau = false;
  this.cap = null;
  this.caq = false;
  this.car = null;
  this.cas = false;
  this.cay = false;
  this.caz = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.cav = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.caA = "TimePayload";
}
export { $c_Lpresto_types$Rule$$anon$94 as $c_Lpresto_types$Rule$$anon$94 };
$p = $c_Lpresto_types$Rule$$anon$94.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$94;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$94() {
}
export { $h_Lpresto_types$Rule$$anon$94 as $h_Lpresto_types$Rule$$anon$94 };
$h_Lpresto_types$Rule$$anon$94.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.cav;
});
$p.L = (function() {
  if ((!this.cao)) {
    this.can = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cao = true;
  }
  return this.can;
});
$p.O = (function() {
  if ((!this.cax)) {
    this.caw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cax = true;
  }
  return this.caw;
});
$p.E = (function() {
  return this.caA;
});
$p.t = (function() {
  if ((!this.cau)) {
    this.cat = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ranges", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cau = true;
  }
  return this.cat;
});
$p.M = (function() {
  if ((!this.caq)) {
    this.cap = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SS(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002etypes$0024$0024anon$002495.$c_Lpresto_types$$anon$95())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.caq = true;
  }
  return this.cap;
});
$p.Q = (function() {
  if ((!this.cas)) {
    this.car = new $j_presto$002etypes$0024$0024anon$0024101.$c_Lpresto_types$$anon$101();
    this.cas = true;
  }
  return this.car;
});
$p.w = (function() {
  if ((!this.caz)) {
    this.cay = false;
    this.caz = true;
  }
  return this.cay;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee148) => ((p) => \u03b4scrutinee148.cGF(p)))($j_presto$002etypes$0024$002dTime$002dPayload$0024.$m_Lpresto_types$TimePayload$())));
});
var $d_Lpresto_types$Rule$$anon$94 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$94, "presto.types$Rule$$anon$94", ({
  a1e: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$94 as $d_Lpresto_types$Rule$$anon$94 };
//# sourceMappingURL=presto.types$-Rule$$anon$94.js.map
